import { authReady, getUser, isSupabaseConfigured, login, signup } from '../lib/auth.js';
import { getSupabaseAuthErrorMessage } from '../lib/supabaseAuthErrors.js';

const root = document.querySelector('[data-auth-page]');
async function initAuthPage() {
  const mode = root.dataset.authPage;
  const form = root.querySelector('[data-auth-form]');
  const submit = root.querySelector('[data-auth-submit]');
  const errorEl = root.querySelector('[data-auth-error]');
  const warning = root.querySelector('[data-auth-config-warning]');

  const showError = (message) => {
    errorEl.textContent = message;
    errorEl.hidden = false;
  };

  if (!isSupabaseConfigured) {
    warning.hidden = false;
    submit.disabled = true;
  }

  await authReady;
  if (getUser()) window.location.replace('/account');

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const data = new FormData(form);
    errorEl.hidden = true;
    submit.disabled = true;
    const original = submit.textContent;
    submit.textContent = mode === 'signup' ? 'Creating account...' : 'Signing in...';
    try {
      if (mode === 'signup') {
        await signup(data.get('email'), data.get('password'), data.get('displayName') || undefined);
      } else {
        await login(data.get('email'), data.get('password'));
      }
      window.location.href = '/account';
    } catch (err) {
      showError(getSupabaseAuthErrorMessage(err, mode === 'signup' ? 'Sign up failed' : 'Login failed'));
      submit.disabled = false;
      submit.textContent = original;
    }
  });
}

if (root) {
  void initAuthPage();
}
